@use 'vars';

$padding-vertical: 11px;
$padding-horizontal: 1px;

.availability-interactions-tooltip {
  &__container {
    display: flex;
    align-items: center;
    gap: vars.$gap-small;
    padding: $padding-vertical $padding-horizontal;
  }
}
